
export enum DisputePartyTypeCd {
	CLAIMANT = 'Claimant',
	CURRENT_DEBTOR = 'CurrentDebtor',
	NEW_DEBTOR = 'NewDebtor',
	ON_BEHALF_OF = 'OnBehalfOf'}

